/**
 * Deterministic table-tennis vocabulary correction after Whisper / Web Speech.
 * No LLM — phrase replacements only (longest match first).
 */

const REPLACEMENTS = [
  // English
  ["four hand", "forehand"],
  ["fourhand", "forehand"],
  ["for hand", "forehand"],
  ["fore hand", "forehand"],
  ["back hand", "backhand"],
  ["top spin", "topspin"],
  ["top-spin", "topspin"],
  ["back spin", "backspin"],
  ["back-spin", "backspin"],
  ["side spin", "sidespin"],
  ["counter top", "counter-top"],
  ["counter-topspin", "counter-top"],
  ["contre top", "contre-top"],
  ["ping pong", "table tennis"],
  ["table-tennis", "table tennis"],

  // French: STT often hears « science » for « séance » (training session).
  ["sciences d'entraînement", "séances d'entraînement"],
  ["sciences d'entrainement", "séances d'entraînement"],
  ["science d'entraînement", "séance d'entraînement"],
  ["science d'entrainement", "séance d'entraînement"],
  ["science d entrainement", "séance d'entraînement"],
  ["science d entraînement", "séance d'entraînement"],
  ["prochaines sciences", "prochaines séances"],
  ["prochaine science", "prochaine séance"],
  ["nouvelles sciences", "nouvelles séances"],
  ["nouvelle science", "nouvelle séance"],
  ["cette science", "cette séance"],
  ["des sciences", "des séances"],
  ["les sciences", "les séances"],
  ["nos sciences", "nos séances"],
  ["vos sciences", "vos séances"],
  ["mes sciences", "mes séances"],
  ["une science", "une séance"],
  ["la science", "la séance"],
  ["ma science", "ma séance"],
  ["ta science", "ta séance"],
  ["sa science", "sa séance"],
];

/** Whole-word only (avoid turning « scientifique » into « séanceifique »). */
const WHOLE_WORD_REPLACEMENTS = [
  ["sciences", "séances"],
  ["science", "séance"],
];

const SORTED = [...REPLACEMENTS].sort((a, b) => b[0].length - a[0].length);

function applyCasing(originalFirstChar, replacement) {
  if (originalFirstChar && originalFirstChar === originalFirstChar.toUpperCase()) {
    return replacement.charAt(0).toUpperCase() + replacement.slice(1);
  }
  return replacement;
}

/**
 * @param {string} raw
 * @returns {string}
 */
export function normalizeTranscription(raw) {
  if (!raw || typeof raw !== "string") return "";
  let text = raw.trim().replace(/\s+/g, " ");
  if (!text) return "";

  let changed = true;
  let guard = 0;
  while (changed && guard++ < 32) {
    changed = false;
    const lower = text.toLowerCase();
    for (const [from, to] of SORTED) {
      if (from === to) continue;
      const idx = lower.indexOf(from);
      if (idx === -1) continue;
      const before = text.slice(0, idx);
      const after = text.slice(idx + from.length);
      text = before + applyCasing(text[idx], to) + after;
      changed = true;
      break;
    }
  }

  for (const [from, to] of WHOLE_WORD_REPLACEMENTS) {
    const re = new RegExp(`\\b${from}\\b`, "gi");
    text = text.replace(re, (match) => applyCasing(match[0], to));
  }

  return text.trim();
}

export const tableTennisVocabulary = Object.fromEntries([
  ...REPLACEMENTS,
  ...WHOLE_WORD_REPLACEMENTS,
]);
